import React, { useState } from 'react'
import { Button, Tooltip } from '@surecompanies/core_components'
import { CloseOutlined, LoadingOutlined } from '@ant-design/icons'
import type { ICellRendererParams } from '@ag-grid-community/core'

interface IgnoreActionCellParams extends ICellRendererParams {
  onIgnore: (row: Record<string, unknown>) => Promise<void>
}

export function IgnoreActionCell(params: IgnoreActionCellParams) {
  const [isIgnoring, setIsIgnoring] = useState(false)
  const row = params.data as Record<string, unknown> | undefined
  if (!row) return null

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <Tooltip title="Ignore deleted row">
        <Button
          icon={isIgnoring ? <LoadingOutlined /> : <CloseOutlined />}
          size="small"
          type="text"
          disabled={isIgnoring}
          onClick={async (e) => {
            e.stopPropagation()
            if (isIgnoring) return
            setIsIgnoring(true)
            try {
              await params.onIgnore(row)
            } catch {
              // error notification handled by parent
            } finally {
              setIsIgnoring(false)
            }
          }}
        />
      </Tooltip>
    </div>
  )
}
